import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const fetchTransactions = createAsyncThunk('transactions/fetch', async (arg) => {
  const { page = 1, limit = 50, status, method } = arg || {};
  
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('limit', String(limit));
  if (status) params.set('status', status);
  if (method) params.set('method', method);

  const res = await axios.get(`/merchant/payments/transactions?${params.toString()}`);
  return res.data;
});

const transactionsSlice = createSlice({
  name: 'transactions',
  initialState: { 
    items: [], 
    total: 0, 
    page: 1, 
    limit: 50,
    status: 'idle', 
    error: null 
  },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchTransactions.pending, (s) => { s.status = 'loading'; })
     .addCase(fetchTransactions.fulfilled, (s, a) => { 
       s.status = 'succeeded'; 
       s.items = a.payload.data.transactions || []; 
       s.total = a.payload.data.pagination?.total || 0;
       s.page = a.payload.data.pagination?.current || 1;
       s.limit = a.payload.data.pagination?.pages || 50;
     })
     .addCase(fetchTransactions.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; });
  }
});

export default transactionsSlice.reducer;




